export default __webpack_public_path__ + "images/hlf-logo_4137cfb7ee623ba9b08c282c9ad01a7b.svg";